import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_matching_sets: FaireCategoryEntity = {
  token: "cat_women-matching-sets",
  type: "category",
  name: "Matching sets",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/matching-sets",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
